import { makeAutoObservable } from "mobx";

export default class ServerStore {
    constructor() {
        this._servers = [];

        makeAutoObservable(this);
    }

    setServers(servers) {
        this._servers = Array.isArray(servers) ? servers : [];
    }

    reset() {
        this.setServers([]);
    }

    get servers() {
        return this._servers;
    }
}
